import { Check } from "lucide-react";
import React from "react";

export default function CheckButton({
  checked = false,
  onClick,
  size = 20,
  className = "",
}) {
  return (
      <div className="flex items-center justify-start ">
      <Check
        onClick={onClick}
        strokeWidth={4}
        style={{ width: size, height: size }}
        className={`cursor-pointer p-1 rounded-md border border-slate-400 transition
          ${
            checked
              ? "bg-blue-500 text-white"
              : "bg-transparent text-white/0"
          }
          ${className}
        `}
      />
    </div>
  )
}
